<template>
  <div>
    <v-list-item
      @click="toggleExpanded"
    >
      <v-list-item-content>
        <v-list-item-title>{{ comment.comment }}</v-list-item-title>
        <v-list-item-subtitle>{{ comment.user.email }}</v-list-item-subtitle>
        <v-list-item-subtitle>{{ comment.created_at | moment('from') }}</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn
          icon
          ripple
          class="ma-0"
          @click="editComment"
        >
          <v-icon
            color="grey lighten-1"
          >
            edit
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-slide-y-transition>
      <div
        v-show="expanded"
        class="pl-4 py-2"
      >
        <div class="caption font-weight-light">
          COMMENT
        </div>
        {{ comment.comment }}
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
  export default {
    name: 'CommentCard',
    props: {
      comment: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        expanded: false
      }
    },
    methods: {
      editComment() {
        this.$emit('edit:comment', this.comment)
      },
      toggleExpanded() {
        this.expanded = !this.expanded
      }
    }
  }
</script>
